






























import { defineComponent } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import BaseIcon from "@/components/BaseIcon";
import BaseInput from "@/components/BaseInput";
import BasePage from "@/components/BasePage";
import BaseSpinner from "@/components/BaseSpinner";
import PageTitle from "@/components/PageTitle";
import SearchUserList from "./SearchUserList.vue";
import { FollowerMappedType } from "../type";

export default defineComponent({
  name: "SearchUserView",
  components: { BasePage, BaseSpinner, BaseInput, BaseIcon, PageTitle, SearchUserList },
  props: {
    screenNameValue: { type: String, default: "" },
    loading: { type: Boolean },
    users: { type: Array as () => UserPublicData[], default: () => [] },
    mappedFollowings: { type: Object as () => FollowerMappedType, default: () => {} },
    followingInProcessUsers: { type: Array as () => string[], default: () => [] },
  },
  computed: {
    hasAppendIcon(): boolean {
      return this.screenNameValue.length > 0;
    },
  },
  methods: {
    follow(user: UserPublicData) {
      this.$emit("follow", user);
    },
  },
});
